import { createStore } from 'vuex'
import jwtDecode from 'jwt-decode'
import { login, reissue } from '@/api/auth.api'

const user = JSON.parse(localStorage.getItem('user'))
const initialState = user
  ? { status: { loggedIn: true }, user }
  : { status: { loggedIn: false }, user: null }
const currentMenu = {
  menuIdx: 0,
  childMenuIdx: 0,
  prevMenuIdx: 0
}

export default createStore({
  state: {
    initialState,
    currentMenu
  },
  getters: {
    isAuthenticated (state) {
      // 현재 로그인 상태인지 확인 (true/false)
      return state.initialState.status.loggedIn
    },

    isAuthUser (state) {
      // 현재 로그인 사용자 개인권한 여부 확인 (true/false)
      const auth = jwtDecode(state.initialState.user.accessToken).auth
      return !!(auth && auth.find(item => item.authorCd === 'ROLE_USER') !== undefined)
    },

    isAuthManager (state) {
      // 현재 로그인 사용자 매니저권한 여부 확인 (true/false)
      const auth = jwtDecode(state.initialState.user.accessToken).auth
      return !!(auth && auth.find(item => item.authorCd === 'ROLE_MANAGER') !== undefined)
    },

    isAuthAdmin (state) {
      // 현재 로그인 사용자 관리자권한 여부 확인 (true/false)
      const auth = jwtDecode(state.initialState.user.accessToken).auth
      return !!(auth && auth.find(item => item.authorCd === 'ROLE_SADMIN' || item.authorCd === 'ROLE_ADMIN' || item.authorCd === 'ROLE_USER_ADMIN') !== undefined)
    },

    isAuthSd (state) {
      // 현재 로그인 사용자 SD권한 여부 확인 (true/false)
      const auth = jwtDecode(state.initialState.user.accessToken).auth
      return !!(auth && auth.find(item => item.authorCd === 'ROLE_SADMIN' || item.authorCd === 'ROLE_ADMIN' || item.authorCd === 'ROLE_SD') !== undefined)
    },

    isModify: (state) => (uiId) => {
      const auth = jwtDecode(state.initialState.user.accessToken).auth
      const account = jwtDecode(state.initialState.user.accessToken).eusr

      return !!(auth && auth.find(item => item.authorCd === 'ROLE_SADMIN' || item.authorCd === 'ROLE_ADMIN' || item.authorCd === 'ROLE_USER_ADMIN' || item.authorCd === 'ROLE_USER' || item.authorCd === 'ROLE_HEAD') !== undefined) || account.uiId === uiId
    },

    isCenterModify: (state) => (uiId) => {
      // 수정 가능 여부 확인
      const auth = jwtDecode(state.initialState.user.accessToken).auth
      const account = jwtDecode(state.initialState.user.accessToken).eusr

      return !!(auth && auth.find(item => item.authorCd === 'ROLE_SADMIN' || item.authorCd === 'ROLE_ADMIN' || item.authorCd === 'ROLE_USER_ADMIN' || item.authorCd === 'ROLE_SD') !== undefined) || account.uiId === uiId
    },

    isSdModify: (state) => (uiId, bzcsSd, bzcsSd2) => {
      // 수정 가능 여부 확인
      const auth = jwtDecode(state.initialState.user.accessToken).auth
      const account = jwtDecode(state.initialState.user.accessToken).eusr

      return !!(auth && auth.find(item => item.authorCd === 'ROLE_SADMIN' || item.authorCd === 'ROLE_ADMIN' || item.authorCd === 'ROLE_USER_ADMIN') !== undefined) || account.uiId === uiId || account.uiId === bzcsSd || account.uiId === bzcsSd2
    },

    isDownload (state) {
      // 엑셀 다운로드 가능 여부 확인
      const auth = jwtDecode(state.initialState.user.accessToken).auth

      return !!(auth && auth.find(item => item.authorCd === 'ROLE_ADMIN' || item.authorCd === 'ROLE_SADMIN'))
    },

    isDownload2 (state) {
      // 엑셀 다운로드 가능 여부 확인
      const auth = jwtDecode(state.initialState.user.accessToken).auth
      const eusr = jwtDecode(state.initialState.user.accessToken).eusr

      return !!((auth && auth.find(item => item.authorCd === 'ROLE_ADMIN' || item.authorCd === 'ROLE_SADMIN')) || (eusr && (eusr.uiId === 'sychoi' || eusr.uiId === 'emjo')))
    },

    getAccount (state) {
      // 사용자정보 불러오기
      return jwtDecode(state.initialState.user.accessToken).eusr
    },

    getRole (state) {
      // 권한 불러오기
      return jwtDecode(state.initialState.user.accessToken).auth
    },

    getMenu (state) {
      // 메뉴 불러오기
      return jwtDecode(state.initialState.user.accessToken).menus
    },

    getAccessToken (state) {
      // AccessToken 불러오기
      return state.initialState.user.accessToken
    },

    getRefreshToken (state) {
      // RefreshToken 불러오기
      return state.initialState.user.refreshToken
    },

    getCurrentMenu (state) {
      // 현재 메뉴 불러오기
      return state.currentMenu
    },

    getFirstMenuUrl (state) {
      // 첫번째 메뉴URL 불러오기
      const menus = jwtDecode(state.initialState.user.accessToken).menus
      return menus[0].menuUrl
    }
  },
  mutations: {
    loginSuccess (state, user) {
      localStorage.setItem('user', JSON.stringify(user))

      state.initialState.status.loggedIn = true
      state.initialState.user = user
    },
    logoutSuccess (state) {
      localStorage.removeItem('user')

      state.initialState.status.loggedIn = false
      state.initialState.user = null
    },
    menuSelected (state, menuSelected) {
      state.currentMenu.menuIdx = menuSelected.parentMeuIdx
      state.currentMenu.childMenuIdx = menuSelected.childMenuIdx
      state.currentMenu.prevMenuIdx = state.currentMenu.menuIdx
    }
  },
  actions: {
    async login ({ commit }, form) {
      const response = await login(form)
      if (response.data.token) {
        commit('loginSuccess', response.data.token)
      }

      return Promise.resolve(response.data)
    },
    async refreshToken ({ commit, rootState }) {
      const accessToken = rootState.initialState.user.accessToken
      const refreshToken = rootState.initialState.user.refreshToken

      const response = await reissue(accessToken, refreshToken)
      if (response.data.accessToken) {
        commit('loginSuccess', response.data)
      }

      return Promise.resolve(response.data)
    },
    async logout ({ commit, rootState }) {
      // const accessToken = rootState.initialState.user.accessToken
      // const refreshToken = rootState.initialState.user.refreshToken

      // await logout(accessToken, refreshToken)
      commit('logoutSuccess')

      return Promise.resolve()
    },
    async menuSelected ({ commit }, menuSelected) {
      commit('menuSelected', menuSelected)

      return Promise.resolve()
    }
  },
  modules: {
  }
})
